import moment from "moment"

export const APP_DATE_FORMAT = "MM/DD/YYYY"
export const APP_INPUTS_DATE_FORMAT = ["m", "d", "Y"]
export const DATABASE_DATE_FORMAT = "YYYY-MM-DD"

export function formatLongDate(value) {
  return moment(value).format("ll")
}

export function formatIntradayLatestPriceTimestamp(value) {
  return moment(value).format("ll. [Latest Price] h:mm A")
}

export function formatShortDate(value) {
  return moment(value).format("MMM D")
}

export function formatNiceShortDate(value) {
  return moment(value).calendar()
}
